module.exports = __webpack_public_path__ + "images/application/illustrations/inbound-blue-12ad5851.svg";